import React, { useState } from 'react';
import { toast } from 'sonner';
import { X, CircleNotch } from '@phosphor-icons/react';
import transportService from '../../services/transportService';
import '../finance/Modal.css';

function VerificationModal({ driver, onClose, onVerified }) {
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await transportService.verifyDriver(driver.id, notes);
      toast.success('Driver verified successfully');
      onVerified(response);
      onClose();
    } catch (error) {
      toast.error(error.message || 'Failed to verify driver');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal modal-lg">
        <div className="modal-header">
          <h2>Verify Driver</h2>
          <button onClick={onClose} className="btn-close">
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleVerify} className="modal-body">
          <div className="form-group">
            <label className="form-label">Driver Name</label>
            <input type="text" value={driver.staff_name || ''} disabled className="form-control" />
          </div>

          <div className="form-row">
            <div>
              <label className="form-label">License Number</label>
              <input type="text" value={driver.license_number} disabled className="form-control" />
            </div>
            <div>
              <label className="form-label">License Expiry</label>
              <input type="text" value={driver.license_expiry || 'N/A'} disabled className="form-control" />
            </div>
          </div>

          <div className="form-row">
            <div>
              <label className="form-label">Insurance Provider</label>
              <input type="text" value={driver.insurance_provider || 'N/A'} disabled className="form-control" />
            </div>
            <div>
              <label className="form-label">Insurance Expiry</label>
              <input type="text" value={driver.insurance_expiry || 'N/A'} disabled className="form-control" />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Verification Notes</label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Enter verification notes (optional)"
              rows="4"
              className="form-control"
            />
          </div>

          <div className="alert alert-info">
            <strong>Note:</strong> Verifying this driver will mark them as approved and set the verification date to today.
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="btn btn-success" disabled={loading}>
              {loading ? (
                <span className="button-loading">
                  <CircleNotch size={16} weight="fill" className="spinner" />
                  Verifying...
                </span>
              ) : 'Verify Driver'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default VerificationModal;
